export const TextIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      d='M53 90.5C53 82.4919 59.4919 76 67.5 76H214.5C222.508 76 229 82.4919 229 90.5C229 98.5081 222.508 105 214.5 105H67.5C59.4919 105 53 98.5081 53 90.5Z'
      fill='#CBD5E0'
    />
    <path
      d='M53 129C53 125.686 55.6863 123 59 123H341C344.314 123 347 125.686 347 129C347 132.314 344.314 135 341 135H59C55.6863 135 53 132.314 53 129Z'
      fill='#38B2AC'
    />
    <path
      d='M53 159C53 155.686 55.6863 153 59 153H341C344.314 153 347 155.686 347 159C347 162.314 344.314 165 341 165H59C55.6863 165 53 162.314 53 159Z'
      fill='#38B2AC'
    />
    <path
      d='M53 189C53 185.686 55.6863 183 59 183H341C344.314 183 347 185.686 347 189C347 192.314 344.314 195 341 195H59C55.6863 195 53 192.314 53 189Z'
      fill='#38B2AC'
    />
    <path
      d='M53 219C53 215.686 55.6863 213 59 213H271C274.314 213 277 215.686 277 219C277 222.314 274.314 225 271 225H59C55.6863 225 53 222.314 53 219Z'
      fill='#38B2AC'
    />
  </svg>
)
